import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Startup from './Startup';
import Simulator from './components/Simulator/Simulator';
import OverviewComponent from './components/OnlineAPI/Pages/Overview';
import GettingStartedComponent from './components/OnlineAPI/Pages/GettingStarted';
import EnviornmentsComponent from './components/OnlineAPI/Pages/Enviornments';
import FeaturesComponent from './components/OnlineAPI/Pages/Features';
import MetaDataComponent from './components/OnlineAPI/Pages/MetaData';
import TerminalOnboardingComponent from './components/OnlineAPI/Pages/TerminalOnboarding';
import TransactionRequestsComponent from './components/OnlineAPI/Pages/TransactionRequests';
import ReportingComponent from './components/OnlineAPI/Pages/Reporting';
import ErrorCodes from './components/OnlineAPI/Pages/ErrorCodes';

import {
    APIReference
} from './components/OnlineAPI/APIReference';
import { Provider } from 'react-redux';
import Store from './Redux/Store';
import Main from './Main';
import { AccessV2APIReference } from './components/Access/APIReference';
import AccessV2GettingStartedComponent from './components/Access/Pages/GettingStarted';
import AccessV2EnviornmentsComponent from './components/Access/Pages/Enviornments';
import AccessV2TIDHandlingComponent from './components/Access/Pages/TIDHandling';
import AccessV2ErrorCodes from './components/Access/Pages/ErrorCodes';
import Demo from './components/Demo/Demo';
import WebDemo from './components/Demo/WebDemo';
import Home from './components/Demo/Home';
import MobileDemo from './components/Demo/MobileDemo';
import SampleEcr from './components/Demo/SampleEcr';
import AccessV2TerminalManagementComponent from './components/Access/Pages/TerminalManagement';

const router = createBrowserRouter([
    {
        path: "/",
        element: <Startup></Startup>,
        children: [
            {
                path: "/",
                element: <Main></Main>,
            },
            {
                path: "/online-api",
                element: <APIReference></APIReference>,
                children: [
                    {
                        path: "/online-api",
                        element: <OverviewComponent></OverviewComponent>
                    },
                    {
                        path: "/online-api/overview",
                        element: <OverviewComponent></OverviewComponent>
                    },
                    {
                        path: "/online-api/getting-started",
                        element: <GettingStartedComponent></GettingStartedComponent>,
                    },
                    {
                        path: "/online-api/environments",
                        element: <EnviornmentsComponent></EnviornmentsComponent>,
                    },
                    {
                        path: "/online-api/metadata",
                        element: <MetaDataComponent></MetaDataComponent>,
                    },
                    {
                        path: "/online-api/terminal-onboarding",
                        element: <TerminalOnboardingComponent></TerminalOnboardingComponent>,
                    },
                    {
                        path: "/online-api/transaction-requests",
                        element: <TransactionRequestsComponent></TransactionRequestsComponent>,
                    },
                    {
                        path: "/online-api/reporting",
                        element: <ReportingComponent></ReportingComponent>,
                    },
                    {
                        path: "/online-api/error-handling",
                        element: <ErrorCodes></ErrorCodes>,
                    },
                    {
                        path: "/online-api/features",
                        element: <FeaturesComponent></FeaturesComponent>,
                    },
                ]
            },
            {
                path: "/access-v2",
                element: <AccessV2APIReference></AccessV2APIReference>,
                children: [
                    {
                        path: "/access-v2",
                        element: <AccessV2GettingStartedComponent></AccessV2GettingStartedComponent>
                    },
                    {
                        path: "/access-v2/getting-started",
                        element: <AccessV2GettingStartedComponent></AccessV2GettingStartedComponent>,
                    },
                    {
                        path: "/access-v2/environments",
                        element: <AccessV2EnviornmentsComponent></AccessV2EnviornmentsComponent>,
                    },
                    {
                        path: "/access-v2/terminal-onboarding",
                        element: <AccessV2TIDHandlingComponent></AccessV2TIDHandlingComponent>,
                    },
                    {
                        path: "/access-v2/terminal-management",
                        element: <AccessV2TerminalManagementComponent></AccessV2TerminalManagementComponent>,
                    },
                    {
                        path: "/access-v2/error-handling",
                        element: <AccessV2ErrorCodes></AccessV2ErrorCodes>,
                    },
                ]
            },
            {
                path: "/simulator",
                element: <Simulator></Simulator>,
            },
            {
                path: "/demo",
                element: <SampleEcr></SampleEcr>,
                children: [
                    {
                        path: "/demo",
                        element: <SampleEcr></SampleEcr>
                    },
                    {
                        path: "/demo/web",
                        element: <WebDemo></WebDemo>
                    },
                    {
                        path: "/demo/mobile",
                        element: <MobileDemo></MobileDemo>
                    }
                ]
            }
        ],
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={Store}>
        <RouterProvider router={router} />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

